import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/stock-ins', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/stock-ins', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/stock-ins/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/stock-ins/${data.stock_in_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/stock-ins/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const getProduct = (Option = {}) => {
  return httpClient
    .get('/api/stock-ins/products')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getExchangRate = (Option = {}) => {
  return httpClient
    .get('/api/stock-ins/exchange-rates')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getUOM = (Option = {}) => {
  return httpClient
    .get('/api/stock-ins/uom')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSupplier = (Option = {}) => {
  return httpClient
    .get('/api/stock-ins/suppliers')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getWareHouse = (Option = {}) => {
  return httpClient
    .get('/api/stock-ins/warehouses')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getPOList = (Option = {}) => {
  return httpClient
    .get('/api/stock-ins/purchase-orders')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getPOResource = (id, Option = {}) => {
  return httpClient
    .get(`/api/stock-ins/purchase-orders/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  getProduct,
  getExchangRate,
  getUOM,
  getSupplier,
  getWareHouse,
  getPOList,
  getPOResource
}
